// extracted by mini-css-extract-plugin
export var icon = "_6t-1";
export var subtext = "_6t-0";